import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { datadogRum } from '@datadog/browser-rum';
import api from '@services/api';

const useGetCustomerTags = () => {
  const [customerTags, setCustomerTags] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  const getTags = useCallback(async (portfolioId?:string) => {
    setLoading(true);
    try {
      const response = await api.get('/customer/tags', {
        params: {
          portfolioId,
        },
      });
      
      setCustomerTags(response.data);
    } catch (error) {
      toast.error('Erro ao carregar as tags. Tente novamente mais tarde.');
      datadogRum.addError(new Error('Fail to get customer tags'), {
        error,
        portfolioId,
      });
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    customerTags,
    getTags,
    loading,
  };
};

export default useGetCustomerTags;
